import {async} from 'regenerator-runtime';
import { API_KEY, API_URL } from './config';
import {RES_PER_PAGE} from './config';
import { AJAX } from './helpers';
import { findIndex } from 'core-js/internals/array-iteration';

export const state = {
  recipe: {},
  search: {
    query: '',
    results: [],
    page: 1,
    resultsPerPage: RES_PER_PAGE,
  },
  bookmarks: [],
}

const createRecipeObject = function(data){
  const { recipe } = data.data;
  return {
    id: recipe.id,
    title: recipe.title,
    publisher: recipe.publisher,
    sourceUrl: recipe.source_url,
    image: recipe.image_url,
    servings: recipe.servings,
    cookingTime: recipe.cooking_time,
    ingredients: recipe.ingredients,
    ...(recipe.key && {key: recipe.key})
  };
}

export const loadRecipe = async function(id) {
  try {
    const data = await AJAX(`${API_URL}${id}?key=${API_KEY}`);
    state.recipe = createRecipeObject(data);
    state.recipe.bookmarked = state.bookmarks.some(b => b.id === id);
  }
  catch(error) {
    throw error;
  }
}

export const loadSearchResults = async function(query){
  try{
    state.search.query = query;
    const data = await AJAX(`${API_URL}?search=${query}&key=${API_KEY}`);

    state.search.results = data.data.recipes.map(recipe => {
      return {
        id: recipe.id,
        title: recipe.title,
        publisher: recipe.publisher,
        image: recipe.image_url,
        ...(recipe.key && {key: recipe.key})
      }
    })

    state.search.page = 1;
  }
  catch(error){
    throw error;
  }
}


export const getSearchResultsPage = function(page = 1){
  state.search.page = page;
  const start = (page-1) * state.search.resultsPerPage;
  const end = page * state.search.resultsPerPage;
  return state.search.results.slice(start, end);
}

export const updateServings = function(servings){
  state.recipe.ingredients.forEach((ingredient) => {
    ingredient.quantity = ingredient.quantity * (servings/state.recipe.servings);
  })
  state.recipe.servings = servings;
}

const persistBookmarks =  function(){
  localStorage.setItem('bookmarks', JSON.stringify(state.bookmarks));
}

export const addBookmark = function(recipe){
  state.bookmarks.push(recipe);
  if(recipe.id === state.recipe.id) state.recipe.bookmarked = true;

  persistBookmarks();
}

export const deleteBookmark = function(id){
  const index = state.bookmarks.findIndex(bookmark => bookmark.id === id);
  state.bookmarks.splice(index, 1);

  if(id === state.recipe.id) state.recipe.bookmarked = false;

  persistBookmarks();
}

const init = function(){
  const storage = localStorage.getItem('bookmarks');
  if(storage) state.bookmarks = JSON.parse(storage);
}
init();

//for debugging
const clearBookmarks = function(){
  localStorage.removeItem('bookmarks');
}

export const uploadRecipe = async function(newRecipe){
  try {
    const ingredients = Object.entries(newRecipe).filter(
      entry => entry[0].startsWith('ingredient') && entry[1] !== '')
      .map(ing => {
        const ingArr = ing[1].split(',').map(el => el.trim());
        if (ingArr.length !== 3) throw new Error(`Wrong ingredient format. Please use the correct format :)`);
        const [quantity, unit, description] = ingArr;
        return { quantity: quantity ? +quantity : null, unit, description };
      })
    const recipe = {
      title: newRecipe.title,
      source_url: newRecipe.sourceUrl,
      image_url: newRecipe.image,
      publisher: newRecipe.publisher,
      cooking_time: +newRecipe.cookingTime,
      servings: +newRecipe.servings,
      ingredients,
    };
    const data = await AJAX(`${API_URL}?key=${API_KEY}`, recipe)
    state.recipe = createRecipeObject(data);
    addBookmark(state.recipe);
  }
  catch(error){
    throw error;
  }
}